import { SwarovskiOptikVideoPlayer } from "../../VideoComponent/VideoComponent";
import React from "react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { VideoType } from "@swo/shared";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../../styles/breakpoints";
import { SharedVideoPropsT } from "../../VideoComponent/types";

export const OverlappingImagesVideoElement: ReactTFC<{ video: VideoType }> = props => {
  return (
    <SwarovskiOptikVideoPlayer
      video={props.video.video}
      subtitles={props.video.subtitles}
      portraitMode={false}
      attachStyles={videoStyles}
      resolutionPickerStrategy={"middle"}
      withPlayerUI={false}
      sharedVideoProps={sharedVideoProps}
      sys={{ id: "" }}
      mode={"fill"}
    />
  );
};

const sharedVideoProps: SharedVideoPropsT = {
  preload: "auto",
  playsInline: "enabled-after-interaction",
  muted: true,
  crossOrigin: "crossorigin" as any,
  loop: true,
  autoPlay: true,
};

const videoStyles = css`
  ${CSS_MQ.atLeastMd} {
    margin: 0;
  }
`;
